import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

import LayoutComponent from "@/components/LayoutComponent.vue";
import { onMounted, watch } from "vue";
import { useStore } from "vuex";
import { RootState } from "./types/state.type";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore<RootState>();

// - on mounted
onMounted(() => {
  // - set window ui data
  window.addEventListener("resize", () => {
    store.commit("ui/setWindow", { height: window.innerHeight, width: window.innerWidth });
  });
  store.commit("ui/setWindow", { height: window.innerHeight, width: window.innerWidth });

  // - check alerts
  checkAlerts();
});

// - watch
watch(
  () => store.getters["auth/loggedIn"],
  () => {
    checkAlerts();
  }
);

// - methods
const checkAlerts = () => {
  if (!store.getters["auth/loggedIn"]) {
    return;
  }

  store.dispatch("ui/checkNotifications");

  // - check every checkPeriod minutes
  setTimeout(() => {
    checkAlerts();
  }, 5 * 60 * 1000);
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(LayoutComponent, null, {
    default: _withCtx(() => [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, {
            name: "fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})